import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { MatFormField, MatHint, MatInput, MatLabel } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { MessageService } from '../../../shared/components/message.service';
import { INPUT_LIMITS } from '../../../shared/constants/input-limits';

@Component({
  selector: 'app-multiline-text-entry',
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    MatIcon,
    MatInput,
    MatMiniFabButton,
    MatFormField,
    MatLabel,
    MatIconButton,
    TranslatePipe,
    MatHint,
  ],
  templateUrl: './multiline-text-entry.component.html',
  styleUrl: './multiline-text-entry.component.scss',
})
export class MultilineTextEntryComponent {
  protected get LIMITS() { return INPUT_LIMITS; }
  @Output() changeEntrypoints = new EventEmitter<string[]>();
  constructor(private messageService: MessageService) {}

  newEntry: string = '';
  private _entrypoints: string[] = [];

  get entrypoints(): string[] {
    return this._entrypoints;
  }

  @Input()
  set entrypoints(value: string[]) {
    this._entrypoints = [...(value || [])];
  }

  remove(idx: number) {
    this._entrypoints.splice(idx, 1);
    this.messageService.success('personalData.successItemDelete');
    this.emitChanges();
  }

  moveDown(idx: number) {
    if (idx < this._entrypoints.length - 1) {
      [this._entrypoints[idx], this._entrypoints[idx + 1]] = [
        this._entrypoints[idx + 1],
        this._entrypoints[idx],
      ];
      this.messageService.success('personalData.successOrderChange');
      this.emitChanges();
    }
  }

  moveUp(idx: number) {
    if (idx > 0) {
      [this._entrypoints[idx], this._entrypoints[idx - 1]] = [
        this._entrypoints[idx - 1],
        this._entrypoints[idx],
      ];
      this.messageService.success('personalData.successOrderChange');
      this.emitChanges();
    }
  }

  addNew() {
    if (!this.newEntry.trim()) return;

    const lines = this.newEntry
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter((l) => l.length > 0);

    this._entrypoints.push(...lines);
    this.messageService.success('personalData.successItemAdd');

    this.newEntry = '';
    this.emitChanges();
  }

  handleChange(idx: number, value: string) {
    this._entrypoints[idx] = value.trim();
    this.emitChanges();
  }

  emitChanges() {
    this.changeEntrypoints.emit([...this._entrypoints]);
  }

  trackByIndex(index: number) {
    return index;
  }
}
